import { createSelector } from "reselect";

const selectUserReducer = state => state.user;

export const selectUser = createSelector(
    [selectUserReducer],
    (user) => user.user
);

export const selectEmailVerificationPending = createSelector(
    [selectUserReducer],
    (user) => user.emailVerificationPending
);

export const selectUserCache = createSelector(
    [selectUserReducer],
    (user) => user.userCache
);

export const selectCacheTimestamp = createSelector(
    [selectUserReducer],
    (user) => user.cacheTimestamp
);
export const selectAuthIsReady = createSelector(
    [selectUserReducer],
    (user) => user.authIsReady
);
export const selectTeamIndex = createSelector(
    [selectUserReducer],
    (user) => user.teamIndex
);
export const selectActivityLog = createSelector(
    [selectUserReducer],
    (user) => user.activityLog
);
export const selectRecentlyViewed = createSelector(
    [selectUserReducer],
    (user) => user.recentlyViewed
);
export const selectUserDataIsLoading = createSelector(
    [selectUserReducer],
    (user) => user.userDataIsLoading
);
export const selectCardCount = createSelector(
    [selectUserReducer],
    (user) => user.cardCount
);
export const selectUserTokens = createSelector(
    [selectUserReducer],
    (user) => user.user.tokens
);
export const selectCurrentUser = createSelector(
    [selectUserReducer],
    (user) => user.user
);

export const selectUsername = createSelector(
    [selectUser],
    (user) => user?.username || null
);

export const selectHasUsername = createSelector(
    [selectUser],
    (user) => Boolean(user?.username)
);

export const selectNeedsUsername = createSelector(
    [selectUser],
    (user) => !user?.username && Boolean(user?.uid)
);

export const selectIsAdmin = createSelector(
    [selectUser],
    (user) => user?.role === "admin"
);